<template>
    <div class="wrapper--section section-testimonials" :style="`--bg: ${background}`">
        <div class="section-container">

        <div class="member-slide">
            <section
                id="carousel-testimonials"
                class="section__header"
                aria-labelledby="carousel-heading"
                aria-describedby="carousel-status"
            >
                <span aria-hidden="true" class="slider-index" v-html="readableIndex" />

                <h2
                    id="carousel-heading"
                    class="title title--dash"
                    v-html="title"
                />
                <p 
                    id="carousel-status"
                    class="sr-only"
                    aria-live="polite" aria-atomic="true"
                    v-html="`Slide ${selected + 1} of ${items.length}`"
                />
                <transition-group tag="div" class="member-slides" name="slide">
                    <div
                        v-for="(item, i) in items"
                        :key="currentSlide + i"
                        v-show="selected === i"
                        role="group"
                        :aria-label="`Slide ${i + 1} of ${items.length}`"
                        :aria-hidden="selected !== i"
                    >

                        <blockquote v-html="items[selected].text" />
                        <footer v-html="items[selected].author" />

                    </div>
                </transition-group>
            </section>
            <div>
                <transition name="fade" mode="out-in">
                <picture :key="selected">
                    <source :srcset="currentSlide.image.url" media="(min-width: 1367px)" />
                    <img :src="currentSlide.image.sizes['large']" width="800" height="800" fetchpriority="high" alt="" />
                </picture>
                </transition>
            </div>
        </div>

        <div class="testimonials__nav">
            <arrow-button
                type="prev"
                text="Prev"
                class="screen"
                :label="`Prev, slide ${this.selected + 1}`"
                :disabled="!isPrev"
                @click.native="prev"
                aria-controls="carousel-testimonials"
            />
            
            <arrow-button
                type="next"
                text="Next"
                class="screen"
                :label="`Next, slide ${(this.selected + 2)}`"
                :disabled="!isNext"
                @click.native="next"
                aria-controls="carousel-testimonials"
            />
        </div>

        </div>

    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'
import { sectionSlider } from './sectionSlider'

export default {
    props: {
        items: {
            type: [Array, Boolean],
        },
        ...textProps,
        ...optionsProps,
    },

    mixins: [
        sectionSlider,
    ],
}
</script>

<style lang="scss" scoped>
.member-slides {
    position: relative;
    --slide-offset: -1em;

    .slide-leave-active {
        transition: none;
        position: absolute;
        opacity: 0;
        width: 100%;
    }
}

.testimonials__nav {
    background: var(--bg);
    padding-block: 2rem;
    margin-block-end: -2rem;
    display: flex;
    gap: 2rem;
}

@media (width < 768px) {
    .member-slides > * {
        min-height: 10ch;
        display: block;
    }
}

.member-slide {
    ::v-deep p {
        line-height: 1.5;
        font-size: 1rem;
    }

    > section {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        padding-bottom: 2rem;

        .title {
            margin-top: 1.25em;
        }
    }

    &s {
        display: grid;
        place-items: start;
        min-height: 18ch;
    }

    footer {
        font-style: italic;
        margin-top: 1.5rem;
    }

    picture {
        width: 100%;
        height: auto;
        display: block;
        aspect-ratio: 1/1;
        overflow: hidden;
        border-radius: 1em;
    }
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}

@media (width > 767px) {
    .testimonials__nav {
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .member-slide {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        gap: 2%;

        &s {
            min-height: 27ch;
        }

        > * {
            flex: 0 1 50%;
        }
        > :first-child {
            padding-right: 10%;
            padding-bottom: 4rem;
        }
        > :last-child {
            aspect-ratio: 1;
            --br: 12px 12px 12px 10em;

            picture {
                aspect-ratio: initial;
            }

            &::before {
                content: '';
                position: absolute;
                inset-block: 0;
                right: 0;
                z-index: 0;
                width: calc(50%);
                background: var(--purple);
                filter: blur(22px);
                opacity: 0.5;
                border-radius: var(--br);
            }
        }

        picture {
            width: 50%;
            position: absolute;
            inset-block: 0;
            right: 0;
            border-radius: var(--br);
        }
    }
}
@media (width > 1280px) {
    .member-slide {
        > :first-child {
            padding-right: 20%;
        }
    }
}
</style>